import { KuposErrorSuccessModal, KuposModal, SvgHome } from '../common';
import React, { Component } from 'react';

import CommonService from '../../services/commonService';
import KuposCheckbox from '../common/KuposCheckbox';
import KuposInput from '../common/KuposInput';
import KuposButton from '../common/KuposButton';
import KuposRadio from '../common/KuposRadio';
import PropTypes from 'prop-types';
import { TermsAndConditions } from '../pages';
import { AppData } from '../../services';

export default class PaymentOptions extends Component {
  static propTypes = {
    onwardBasicFare: PropTypes.func,
    isOwnTravel: PropTypes.bool,
    operatorTnc: PropTypes.string,
    onPaymentSelect: PropTypes.func,
    selected: PropTypes.number,
    paymentGatewayList: PropTypes.array,
    isLoggedIn: PropTypes.bool,
    walletMoney: PropTypes.string,
    checkWallet: PropTypes.func,
    walletChecked: PropTypes.bool,
    onPay: PropTypes.func,
    bookTicketPending: PropTypes.bool,
    isLoading: PropTypes.bool,
    bookingError: PropTypes.string,
    onBookingErrorClick: PropTypes.func,
    onPromoCheckboxChange: PropTypes.func,
    promoCodeChecked: PropTypes.bool,
    promoCode: PropTypes.string,
    onPromoCodeChange: PropTypes.func,
    onPromoCodeBlur: PropTypes.func,
    onApplyPromoCode: PropTypes.func,
    applyPromoCodePending: PropTypes.bool,
    promoCodeError: PropTypes.string,
    tncChecked: PropTypes.bool,
    onTncChange: PropTypes.func,
    t: PropTypes.func,
    history: PropTypes.object,
    totalAmount: PropTypes.number,
    showPromocode: PropTypes.bool,
    showKuposPay: PropTypes.bool,
    showPaypal: PropTypes.bool,
    showBancoEstado: PropTypes.bool,
    corporateDiscountState: PropTypes.object,
    instantDiscount: PropTypes.object,
    ftmDiscount: PropTypes.object,
    setMotData: PropTypes.func,
    hidePG: PropTypes.bool,
  };
  constructor(props) {
    super(props);
    this.state = {
      tncError: false,
      cardChecked: false,
      isOneClickEnabled: this.props.isOneClickEnabled,
      validMotOtp: false,
    };
  }

  tncChanged = () => {
    this.setState({ tncError: false });
    this.props.onTncChange();
  };

  onPay = () => {
    if (
      !this.props.selected &&
      !this.state.oneClickChecked1 &&
      !this.state.oneClickChecked2 &&
      !this.props.walletChecked &&
      !this.props.virtualChecked &&
      !this.props.is_mot
    ) {
      // if (!this.props.selected && !this.props.cardChecked && this.props.totalAmount > 0) {
      this.setState({ paymentError: true });
      return;
    } else {
      this.setState({ paymentError: false });
    }
    if (!this.props.tncChecked) {
      this.setState({ tncError: true });
      return;
    } else {
      this.setState({ tncError: false });
    }

    if (
      !this.props.is_mot &&
      !this.props.selected &&
      this.props.walletChecked &&
      this.props.walletMoney < this.props.totalAmount
    ) {
      this.setState({ walletMoneyError: true });
      return;
    }

    if (
      !this.props.is_mot &&
      !this.props.selected &&
      this.props.virtualChecked &&
      this.props.virtualMoney < this.props.totalAmount
    ) {
      this.setState({ virtualMoneyError: true });
      return;
    }

    if (
      !this.props.is_mot &&
      !this.props.selected &&
      this.props.walletChecked &&
      this.props.virtualChecked &&
      this.props.walletMoney + this.props.virtualMoney < this.props.totalAmount
    ) {
      this.setState({ walletMoneyError: true });
      return;
    }

    this.props.onPay();
  };

  sendSMS = () => {
    if (!this.state.mot_number) {
      this.setState({ mot_number_eror: true });
      return;
    }

    if (!this.state.mot_phone) {
      this.setState({ mot_phone_eror: true });
      return;
    }

    let schedule_id =
      this.props &&
      this.props.selectedServiceRouteOnward &&
      this.props.selectedServiceRouteOnward.id &&
      this.props.selectedServiceRouteOnward.id;
    let mot_number = this.state.mot_number || null;
    let mot_phone = this.state.mot_phone || null;

    this.setState({ isLoading: true });
    this.props.actions
      .apiCall({
        url:
          AppData.BASE_URL +
          `/api/services/validate_mot_coupon.json?schedule_id=${schedule_id}&mot_coupon=${mot_number}&mobile_no=${mot_phone}`,
        type: 'home',
      })
      .then(
        res => this.onValidateMotCouponResponse(res),
        err => this.onValidateMotCouponResponse(err),
      );
  };

  onValidateMotCouponResponse = res => {
    if (res && res.data && res.data.status == 200 && res.data.data) {
      this.setState({
        resMotMessage: res.data.message,
        showMOTModel: true,
        isLoading: false,
        successMOTModel: true,
        isValidMotcode: true,
        validMotAndNumberError: false,
      });
    } else {
      this.setState({
        resMotMessage: res.data.message,
        // showMOTModel: true,
        validMotAndNumberError: true,
        isLoading: false,
        // successMOTModel: false,
      });
    }
  };

  verifyOTP = () => {
    if (!this.state.mot_otp) {
      this.setState({ mot_otp_eror: true });
      return;
    }
    this.setState({ isLoadingOtp: true });
    this.props.actions
      .apiCall({
        url:
          AppData.BASE_URL +
          `/api/services/validate_sms_code.json?code=${this.state.mot_otp}&mot_code=${this.state.mot_number}`,
        type: 'home',
      })
      .then(
        res => this.onValidateSMSCodeResponse(res),
        err => this.onValidateSMSCodeResponse(err),
      );
  };

  onValidateSMSCodeResponse = res => {
    if (res && res.data && res.data.status === 200) {
      this.setState({
        resMotMessage: res.data.message,
        showMOTModel: true,
        isLoadingOtp: false,
        validMotOtp: true,
        successMOTModel: true,
        paymentError: false,
        validMotOtpError: false,
      });
      this.props.setMotData(res.data.data);
    } else {
      this.setState({
        resMotMessage: res.data.message,
        // showMOTModel: true,
        isLoadingOtp: false,
        validMotOtp: false,
        // successMOTModel: false,
        validMotOtpError: true,
      });
    }
  };

  changeCardSelection = (val, key) => {
    // this.props.kuposPayChecked ? this.props.onKuposCheck() : null;
    this.props.cardChoosen(val, key);
    this.props.onPaymentSelect(null);
    // onPaymentSelect;

    key == 0
      ? this.setState({
          oneClickChecked1: !this.state.oneClickChecked1,
          oneClickChecked2: false,
          // selectedCard: val,
          amountError: false,
          cardChecked: !this.state.cardChecked,
          paymentError: false,
        })
      : this.setState({
          oneClickChecked2: !this.state.oneClickChecked2,
          oneClickChecked1: false,
          // selectedCard: val,
          amountError: false,
          cardChecked: !this.state.cardChecked,
          paymentError: false,
        });
  };

  renderMyCard = (val, key) => {
    return (
      <div
        key={key}
        onClick={() =>
          key == 0 ? this.changeCardSelection(val, key) : this.changeCardSelection(val, key)
        }
      >
        <div className="card-item" key={key}>
          <div className="txn-item d-flex ">
            <div className="card-image-container">
              {key == 0 ? (
                <KuposRadio
                  disabled={true}
                  checked={this.state.oneClickChecked1 && this.props.cardChecked}
                />
              ) : (
                <KuposRadio
                  disabled={true}
                  checked={this.state.oneClickChecked2 && this.props.cardChecked}
                />
              )}
              {/* <div className="payment-radio-button">
                {key == 0
                  ? this.state.oneClickChecked1 &&
                    this.props.cardChecked && <div className="payment-radio-button-inner" />
                  : this.state.oneClickChecked2 &&
                    this.props.cardChecked && <div className="payment-radio-button-inner" />}
              </div> */}
              <img
                width={42}
                style={{ width: 42 }}
                src={
                  this.props.cardTypes && this.props.cardTypes[val[2]] == 'americanexpress'
                    ? '/images/cards/americanexpress.png'
                    : this.props.cardTypes[val[2]] == 'diners'
                    ? '/images/cards/diners.png'
                    : this.props.cardTypes[val[2]] == 'magna'
                    ? '/images/cards/magna.png'
                    : this.props.cardTypes[val[2]] == 'mastercard'
                    ? '/images/cards/mastercard.png'
                    : this.props.cardTypes[val[2]] == 'redcompra'
                    ? '/images/cards/redcompra.png'
                    : '/images/cards/visa.png'
                }
                alt=""
              />
            </div>
            <div>
              <span className="font10">
                {val[0].replace(/X/gi, '*').substring(8, 12) + ' ' + val[0].substring(12, 16)}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderMOTBlock = t => {
    return (
      <div>
        <div className="mb-20">
          <div className="bold-text font13">{t('PASSENGER_DETAILS.MOT_HEADING')}</div>
          <span className="font10">{t('PASSENGER_DETAILS.MOT_SUB_HEADING')}</span>
        </div>
        <div className="is-mot-input">
          <KuposInput
            label={t('PASSENGER_DETAILS.MOT_NUMBER')}
            type="default"
            className="kupos-border"
            onChange={text => {
              this.setState({ mot_number: text, mot_number_eror: false });
            }}
            onBlur={text => {}}
            error={this.state.mot_number_eror ? true : false}
            errorMessage={t('PASSENGER_DETAILS.INSERT_MOT_NUMBER_ERROR')}
            labelMarginBottom={{ marginBottom: 5 }}
            placeholder={'MOTXXXXXX'}
          />

          <KuposInput
            label={t('PASSENGER_DETAILS.MOT_PHONE')}
            type="default"
            className="kupos-border"
            onChange={text => {
              this.setState({ mot_phone: text, mot_phone_eror: false });
            }}
            onBlur={text => {}}
            error={this.state.mot_phone_eror ? true : false}
            errorMessage={t('PASSENGER_DETAILS.INSERT_MOT_PHONE_ERROR')}
            labelMarginBottom={{ marginBottom: 5 }}
            placeholder={'999999999'}
          />

          <KuposButton
            onClick={this.sendSMS}
            className="font12 mt-12 w-100"
            disabled={this.state.isLoading}
          >
            {this.state.isLoading ? (
              <div className="loader-cricle"></div>
            ) : (
              <span>{t('PASSENGER_DETAILS.MOT_SEND_CODE')}</span>
            )}
          </KuposButton>
        </div>
        <div className="red-text font9 mt-2 mb-3">
          {this.state.validMotAndNumberError ? this.state.resMotMessage : null}
        </div>

        <div className="is-mot-input-grid mt-12">
          <KuposInput
            label={t('PASSENGER_DETAILS.MOT_OTP')}
            type="default"
            className="kupos-border"
            onChange={text => {
              this.setState({ mot_otp: text, mot_otp_eror: false });
            }}
            onBlur={text => {}}
            error={this.state.mot_otp_eror ? true : false}
            errorMessage={t('PASSENGER_DETAILS.INSERT_MOT_OTP_ERROR')}
            labelMarginBottom={{ marginBottom: 5 }}
          />

          <KuposButton
            onClick={this.verifyOTP}
            className="font12 mt-12 "
            disabled={!this.state.isValidMotcode || this.state.isLoadingOtp}
          >
            {this.state.isLoadingOtp ? (
              <div className="loader-cricle"></div>
            ) : (
              <span>APLICAR CODIGO</span>
            )}
          </KuposButton>
        </div>
        <div className="red-text font9 mt-2 mb-3">
          {this.state.validMotOtpError ? this.state.resMotMessage : null}
        </div>
      </div>
    );
  };

  render() {
    const { t } = this.props;
    console.log('🚀 ~ render ~ t:', this.props);

    return (
      <div className="common-payment-options">
        <div className="kupos-card payment-block">
          <div className="payment-block-heading font13">
            {this.props.is_mot ? (
              this.renderMOTBlock(t)
            ) : (
              <div>
                {t('PASSENGER_DETAILS.PAYMENT_OPTIONS.NORMAL')}
                <span className="bold font13">{t('PASSENGER_DETAILS.PAYMENT_OPTIONS.BOLD')}</span>
              </div>
            )}
          </div>

          {/* {this.props.showPromocode &&
          !this.props.corporateDiscountState &&
          !this.props.instantDiscount ? (
            <div className="payment-block-promo flex-row font11">
              <KuposCheckbox
                label={t('PASSENGER_DETAILS.PROMO_CODE')}
                onChange={this.props.onPromoCheckboxChange}
                checked={this.props.promoCodeChecked}
              />
              {this.props.promoCodeChecked ? (
                <div className="promocode-box flex-row">
                  <KuposInput
                    className="kupos-border"
                    type="text"
                    placeholder={t('PASSENGER_DETAILS.INSERT_PROMO')}
                    value={this.props.promoCode}
                    onChange={this.props.onPromoCodeChange}
                    onBlur={this.props.onPromoCodeBlur}
                    error={this.props.promoCodeError ? true : false}
                    errorMessage={this.props.promoCodeError}
                  />
                  <button
                    className="kupos-button font12"
                    disabled={this.props.applyPromoCodePending ? true : false}
                    onClick={this.props.onApplyPromoCode}
                  >
                    {this.props.applyPromoCodePending ? (
                      <div className="loader-cricle"></div>
                    ) : (
                      <span>{t('PASSENGER_DETAILS.APPLY')}</span>
                    )}
                  </button>
                </div>
              ) : null}
            </div>
          ) : null} */}

          <div className="flex-row payment-methods">
            {/* {this.props.paymentGatewayList &&
              this.props.paymentGatewayList.map((item, key) =>
                item.status === 0 &&
                ((this.props.showPaypal &&
                  item.label
                    .toLowerCase()
                    .split(' ')
                    .join('-') === 'paypal') ||
                  item.label
                    .toLowerCase()
                    .split(' ')
                    .join('-') === 'web-pay-plus' ||
                  (this.props.showKuposPay &&
                    item.label
                      .toLowerCase()
                      .split(' ')
                      .join('-') === 'one-click' &&
                    this.props.isLoggedIn) ||
                  (this.props.showBancoEstado &&
                    item.label
                      .toLowerCase()
                      .split(' ')
                      .join('-') === 'banco-estado')) ? (
                  <div
                    className="webpay-payment-method"
                    key={key}
                    onClick={() => {
                      this.setState({
                        paymentError: null,
                        tncError: null,
                        cardChecked: false,
                        oneClickChecked1: false,
                        oneClickChecked2: false,
                        walletMoneyError: false,
                        virtualMoneyError: false,
                      });
                      this.props.onPaymentSelect(item);
                    }}
                  >
                    <KuposRadio
                      // onChange={() => this.props.onPaymentSelect(item)}
                      checked={item.code == this.props.selected}
                    />

                    <div className="payment-checkbox"></div>
                    {item.label
                      .toLowerCase()
                      .split(' ')
                      .join('-') == 'web-pay-plus' ? (
                      <img src="/images/webpay_logo.png" alt="" />
                    ) : null}
                    {item.label
                      .toLowerCase()
                      .split(' ')
                      .join('-') == 'paypal' ? (
                      <img src="/images/paypal_logo.png" alt="" />
                    ) : null}
                    {item.label
                      .toLowerCase()
                      .split(' ')
                      .join('-') == 'banco-estado' ? (
                      <img
                        // style={{width:"25vw"}}
                        src={'/images/banco-estado.png'}
                        alt=""
                      />
                    ) : null}
                    {item.label
                      .toLowerCase()
                      .split(' ')
                      .join('-') != 'paypal' &&
                      item.label
                        .toLowerCase()
                        .split(' ')
                        .join('-') != 'web-pay-plus' &&
                      item.label
                        .toLowerCase()
                        .split(' ')
                        .join('-') != 'banco-estado' ? (
                      <img
                        src={'/images/one-click.png'}
                        alt=""
                      />
                    ) : null}
                  </div>
                ) : null,
              )} */}

            {!this.props.is_mot &&
              this.props.paymentGatewayList &&
              this.props.paymentGatewayList
                .filter(gateway => {
                  if (
                    !this.props.myCards &&
                    this.props.isLoggedIn &&
                    this.props.isOneClickEnabled == 'true'
                  ) {
                    return (
                      gateway.label
                        .toLowerCase()
                        .split(' ')
                        .join('-') != 'web-pay-plus'
                    );
                  } else if (
                    this.props.myCards &&
                    this.props.myCards.length == 1 &&
                    this.props.isLoggedIn &&
                    this.props.isOneClickEnabled == 'true'
                  ) {
                    return (
                      gateway.label
                        .toLowerCase()
                        .split(' ')
                        .join('-') != 'web-pay-plus'
                    );
                  } else if (
                    this.props.myCards &&
                    this.props.myCards.length == 2 &&
                    this.props.isLoggedIn &&
                    this.props.isOneClickEnabled == 'true'
                  ) {
                    return (
                      gateway.label
                        .toLowerCase()
                        .split(' ')
                        .join('-') != 'one-click'
                    );
                  } else {
                    return gateway;
                  }
                })
                .map((item, key) =>
                  !this.props.hidePG &&
                  item.status === 0 &&
                  ((this.props.showPaypal &&
                    item.label
                      .toLowerCase()
                      .split(' ')
                      .join('-') === 'paypal') ||
                    item.label
                      .toLowerCase()
                      .split(' ')
                      .join('-') === 'web-pay-plus' ||
                    item.label
                      .toLowerCase()
                      .split(' ')
                      .join('-') === 'web-pay-plus-kupos' ||
                    // (this.props.showKuposPay &&
                    (this.props.isOneClickEnabled &&
                      item.label
                        .toLowerCase()
                        .split(' ')
                        .join('-') === 'one-click' &&
                      this.props.isLoggedIn &&
                      this.props.isOwnTravel) ||
                    (this.props.showBancoEstado &&
                      item.label
                        .toLowerCase()
                        .split(' ')
                        .join('-') === 'banco-estado')) ? (
                    <div
                      className="webpay-payment-method"
                      key={key}
                      onClick={() => {
                        this.setState({
                          paymentError: null,
                          tncError: null,
                          cardChecked: false,
                          oneClickChecked1: false,
                          oneClickChecked2: false,
                          walletMoneyError: false,
                          virtualMoneyError: false,
                        });
                        this.props.onPaymentSelect(item);
                      }}
                    >
                      <KuposRadio
                        // onChange={() => this.props.onPaymentSelect(item)}
                        checked={item.code == this.props.selected && !this.props.cardChecked}
                      />

                      <div className="payment-checkbox"></div>
                      {item.label
                        .toLowerCase()
                        .split(' ')
                        .join('-') == 'web-pay-plus' ||
                      item.label
                        .toLowerCase()
                        .split(' ')
                        .join('-') == 'web-pay-plus-kupos' ? (
                        <img src="/images/webpay_logo_new.svg" alt="" />
                      ) : // <img src="/images/webpay_logo.png" alt="" />
                      null}
                      {item.label
                        .toLowerCase()
                        .split(' ')
                        .join('-') == 'paypal' ? (
                        <img src={'/images/paypal_logo.png'} alt="" />
                      ) : null}
                      {item.label
                        .toLowerCase()
                        .split(' ')
                        .join('-') == 'banco-estado' ? (
                        <img
                          // style={{width:"25vw"}}
                          src={'/images/banco-estado.png'}
                          alt=""
                        />
                      ) : null}
                      {item.label
                        .toLowerCase()
                        .split(' ')
                        .join('-') != 'paypal' &&
                      item.label
                        .toLowerCase()
                        .split(' ')
                        .join('-') != 'web-pay-plus' &&
                      item.label
                        .toLowerCase()
                        .split(' ')
                        .join('-') != 'web-pay-plus-kupos' &&
                      item.label
                        .toLowerCase()
                        .split(' ')
                        .join('-') != 'banco-estado' ? (
                        <img
                          src={
                            this.props.isOneClickEnabled == 'true' &&
                            (!this.props.myCards || this.props.myCards.length == 1)
                              ? '/images/webpay_logo_new.svg'
                              : '/images/one-click.png'
                          }
                          // src={'/images/one-click.png'}
                          alt=""
                        />
                      ) : null}
                    </div>
                  ) : null,
                )}

            {!this.props.is_mot &&
            this.props.isLoggedIn &&
            this.props.showKuposPay &&
            this.props.isOwnTravel ? (
              <div className="kupos-payment-moneys kupos-pay-method">
                <div
                  className="kupos-payment-method kupos-pay bold-text font10"
                  onClick={this.props.checkWallet}
                  style={{ marginTop: 10, textAlign: 'right' }}
                >
                  <div className="flex-row kupos-pay-check">
                    <KuposRadio disabled={true} checked={this.props.walletChecked} />{' '}
                    <img
                      onClick={() => {
                        this.setState({ paymentError: null, tncError: null });
                        this.props.checkWallet();
                      }}
                      src="/images/pullman-pay-logo.svg"
                      alt=""
                    />{' '}
                  </div>
                  <span className="kupos-amount">
                    {' '}
                    {this.props.isLoggedIn
                      ? CommonService.currency(this.props.walletMoney).split(',')[0]
                      : 'CLP $0'}
                  </span>
                </div>
              </div>
            ) : null}

            {!this.props.is_mot &&
            this.props.isLoggedIn &&
            this.props.showKuposPay &&
            !this.props.hideCreditos &&
            this.props.isOwnTravel &&
            !(
              (this.props.selectedServiceRouteOnward &&
                this.props.selectedServiceRouteOnward.travel_id != AppData.CREDITOS_TRAVEL_ID) ||
              (this.props.selectedServiceRouteReturn &&
                this.props.selectedServiceRouteReturn.travel_id != AppData.CREDITOS_TRAVEL_ID)
            ) ? (
              <div className="kupos-payment-moneys kupos-pay-method">
                <div
                  className="kupos-credit bold-text font10"
                  style={{ marginTop: 10, textAlign: 'right' }}
                >
                  <div
                    className="d-flex mb-1"
                    onClick={() => {
                      this.setState({ paymentError: null, tncError: null });
                      this.props.checkVirtual();
                    }}
                  >
                    <KuposCheckbox
                      checked={this.props.virtualChecked}
                      // onChange={() => {
                      //   this.setState({ paymentError: null, tncError: null });
                      //   this.props.checkVirtual();
                      // }}
                      // label={'PullmanCréditos'}
                      labelStyle={{ fontSize: 12 }}
                      labelBold={true}
                    />
                    <img
                      // onClick={() => {
                      //   this.setState({ paymentError: null, tncError: null });
                      //   this.props.checkWallet();
                      // }}
                      src="/images/CheckOut-PaymentMethods-PullmanCreditos.svg"
                      // style={{ width: '110px' }}
                      alt=""
                    />{' '}
                  </div>
                  <span className="kupos-amount d-inline-block">
                    {' '}
                    {this.props.isLoggedIn
                      ? CommonService.currency(this.props.virtualMoney).split(',')[0]
                      : 'CLP $0'}
                  </span>
                </div>
              </div>
            ) : null}

            {!this.props.is_mot &&
            this.props.myCards &&
            (this.props.isOneClickEnabled == 'true' || this.props.showCards)
              ? this.props.myCards.map((val, key) => this.renderMyCard(val, key))
              : null}
            {/* <div className="kupos-payment-method">    
                   </div> */}
          </div>

          <div className="accept-tnc font10">
            <KuposCheckbox checked={this.props.tncChecked} onChange={this.tncChanged} />
            {/* <a onClick={() => this.setState({ showTNCModel: true })}> */}

            <div>
              {this.props.operatorTnc ? (
                <span
                  style={{ textAlign: 'justify' }}
                  dangerouslySetInnerHTML={{ __html: this.props.operatorTnc }}
                ></span>
              ) : (
                <a onClick={() => this.setState({ showTNCModel: true })} className="link-underline">
                  {t('PASSENGER_DETAILS.I_ACCEPT_TNC_COVID_PART1')}
                </a>
              )}
              {/* <a href="https://c19.cl/" target="_blank" style={{ color: 'blue' }}>
                c19.cl
              </a> */}

              {/* <a onClick={() => this.setState({ showTNCModel: true })}> */}
              {/* <a>{t('PASSENGER_DETAILS.I_ACCEPT_TNC_COVID_PART2')}</a> */}
            </div>
          </div>

          {this.state.tncError ? (
            <div className="tnc-error red-text font10 center-text">
              {t('PASSENGER_DETAILS.PLEASE_ACCEPT_TNC')}
            </div>
          ) : null}
          {this.state.paymentError ? (
            <div className="tnc-error red-text font10 center-text">
              {t('PASSENGER_DETAILS.PLEASE_SELECT_PAYMENT')}
            </div>
          ) : null}

          {this.state.walletMoneyError || this.state.virtualMoneyError ? (
            <div className="tnc-error red-text font10 center-text">
              {t('PASSENGER_DETAILS.INSUFFICIENT_BALANCE')}
            </div>
          ) : null}

          {/* {this.state.virtualMoneyError ? 
            <div className="tnc-error red-text font10 center-text">
              {t('PASSENGER_DETAILS.INSUFFICIENT_BALANCE')}
            </div> : null} */}

          <div className="pay-now-section font13">
            <button
              onClick={this.onPay}
              className="pay-now-button kupos-button"
              // disabled={this.props.bookTicketPending ? true : false}
              disabled={
                this.props.is_mot && !this.state.validMotOtp
                  ? true
                  : this.props.bookTicketPending
                  ? true
                  : false
              }
            >
              {this.props.bookTicketPending || this.props.isLoading ? (
                <div className="loader-cricle"></div>
              ) : (
                <span>{t('PASSENGER_DETAILS.PAY')}</span>
              )}
            </button>
          </div>
          <KuposErrorSuccessModal
            showModal={this.props.bookingError ? true : false}
            success={false}
            onButtonClick={this.props.onBookingErrorClick}
            bodyText={this.props.bookingError}
          />
        </div>

        <KuposModal
          ariaLabel="tnc-pnr-modal-outer"
          size={'xl'}
          onHide={() => this.setState({ showTNCModel: false })}
          showModal={this.state.showTNCModel}
        >
          <div className="tnc-pnr-modal">
            <TermsAndConditions t={this.props.t} />
            <div
              className="close-button pointer"
              onClick={() => this.setState({ showTNCModel: false })}
            >
              <SvgHome name="close" />
            </div>
          </div>
        </KuposModal>

        <KuposErrorSuccessModal
          showModal={this.state.showMOTModel}
          success={this.state.successMOTModel}
          onButtonClick1={() => this.setState({ showMOTModel: false })}
          bodyText={this.state.resMotMessage}
          showButton1
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/PaymentOptions.js